import { onConfigurableProductFragment } from './Fragments/onConfigurableProductFragment'
import { ProductItemFragment } from './Fragments/ProductItemFragment'
import { CustomProductItemFragment } from './Fragments/CustomProductItemFragment'
import { onGiftCardProductFragment } from './Fragments/onGiftCardProductFragment'
import { onBundleProductFragment } from './Fragments/onBundleProductFragment'
import { AssociatedProductsFragment } from './Fragments/AssociatedProductsFragment'

export const productDetailQuery = /* GraphQL */ `
    query productDetail($searchCriteria: [SearchCriteriaInput!]!, $pageSize: Int = 10, $currentPage: Int = 1) {
        productDetail: products(
            searchCriteria: $searchCriteria
            pageSize: $pageSize
            currentPage: $currentPage
        ) {
            items {
                uid
                is_set
                ppum
                ${ProductItemFragment}
                ${CustomProductItemFragment}
                ${AssociatedProductsFragment}
                short_description {
                    __typename
                    html
                }
                description {
                    __typename
                    html
                }
                media_gallery {
                    __typename
                    url
                    disabled
                    label
                    position
                    ... on ProductVideo {
                        video_content {
                            media_type
                            video_provider
                            video_url
                            video_title
                            video_description
                            video_metadata
                        }
                    }
                }
                categories {
                    __typename
                    name
                    url_path
                    breadcrumbs {
                        __typename
                        category_uid
                        category_name
                    }
                }
                ${onConfigurableProductFragment}
                ${onBundleProductFragment}
                ${onGiftCardProductFragment}
                related_products {
                    ${ProductItemFragment}
                    ${onConfigurableProductFragment}

                    media_gallery {
                        __typename
                        disabled
                        label
                        position
                        url
                        ... on ProductVideo {
                            video_content {
                                media_type
                                video_provider
                                video_url
                                video_title
                                video_description
                                video_metadata
                                __typename
                            }
                            __typename
                        }
                    }
                    short_description {
                        __typename
                        html
                    }
                    description {
                        __typename
                        html
                    }
                    medidas_de_embalaje_y_peso
                    medidas_y_materialidad
                }
                fbt_products {
                    ${ProductItemFragment}
                    ${onConfigurableProductFragment}
                }
                meta_title
                meta_keyword
                meta_description
                canonical_url
                badge_image_text
                badge_caption_icon
                new_from_date
                new_to_date
                flag {
                    type
                    label
                    from
                    to
                }
                rating_summary
                review_count
                reviews {
                    items {
                        average_rating
                        created_at
                        nickname
                        ratings_breakdown {
                            name
                            value
                        }
                        summary
                        text
                    }
                    page_info {
                        current_page
                        page_size
                        total_pages
                    }
                }
            }
        }
    }
`

export const productsBySkuQuery = /* GraphQL */ `
    query getProductsBySku($skus: [String], $pageSize: Int) {
        products(filter: { sku: { in: $skus } }, pageSize: $pageSize) {
            items {
                __typename
                id
                name
                sku
                is_set
                ppum
                small_image {
                    url
                }
                uid
                url_key
                media_gallery {
                    __typename
                    url
                }
                short_description {
                    __typename
                    html
                }
                rating_summary
                review_count
                medidas_y_materialidad
                price_range {
                    __typename
                    minimum_price {
                        regular_price {
                            value
                            currency
                        }
                        final_price {
                            value
                            currency
                        }
                        discount {
                            amount_off
                        }
                    }
                }
                special_price
            }
            total_count
            aggregations {
                attribute_code
                count
                label
                options {
                    label
                    value
                    count
                }
            }
        }
    }
`

/**
 * Query for SRP quick-add: needs configurable_options + variants.
 * EVO-263: tambien trae `associated_products` para las miniaturas de color, ya
 * que Live Search no devuelve campos de Magento y el SRP se enriquece por aqui.
 */
export const productConfigurableBySkuQuery = /* GraphQL */ `
    query getProductConfigurableBySku($skus: [String]) {
        products(filter: { sku: { in: $skus } }) {
            items {
                ${ProductItemFragment}
                uid
                ${AssociatedProductsFragment}
                ${onConfigurableProductFragment}
            }
        }
    }
`
